import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const interviewProblemSolving = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    problemSolvingScore: z
      .number()
      .nullable()
      .optional()
      .describe('Score for problem solving ability.'),

    notes: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Interviewer notes on performance and problem solving.'),

    interviewId: z.number().hidden().describe('Foreign key to Interview'),

    interview: belongsTo('Interview'),
  })
  .describe(
    'Performance and problem solving scores from the candidate interview.',
  )
  .as('InterviewProblemSolving');

export { interviewProblemSolving as interviewProblemSolvingSchema };
